<template>
  <div class="slideshow" ref="slideshow">
    <img v-for="(slide, i) in content" :src="slide.sizes.large" class="carousel-cell" :key="`slide${i}`">
  </div>
</template>

<script>
import Flickity from 'flickity'
import 'flickity-imagesloaded'

export default {
  name: 'Slideshow',
  props: ['content'],

  data: () => ({ slideshow: null }),

  mounted () {
    this.slideshow = new Flickity(this.$refs.slideshow, {
      contain: true,
      wrapAround: true,
      cellAlign: 'left',
      imagesLoaded: true
    })
  }
}
</script>
